module.exports = "<!-- Copyright The Linux Foundation and each contributor to LFX. -->\n<!-- SPDX-License-Identifier: MIT -->\n<div>\n  <!-- Loading auth... -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/auth-page/auth-page.component.html
// module id = ./src/app/shared/auth-page/auth-page.component.html
// module chunks = main